/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateResultSpec } from './FormulaEvaluateResultSpec';
import {
    FormulaEvaluateResultSpecFromJSON,
    FormulaEvaluateResultSpecFromJSONTyped,
    FormulaEvaluateResultSpecToJSON,
    FormulaEvaluateResultSpecToJSONTyped,
} from './FormulaEvaluateResultSpec';
import type { FormulaEvaluateValue } from './FormulaEvaluateValue';
import {
    FormulaEvaluateValueFromJSON,
    FormulaEvaluateValueFromJSONTyped,
    FormulaEvaluateValueToJSON,
    FormulaEvaluateValueToJSONTyped,
} from './FormulaEvaluateValue';
import type { FormulaEvaluateTableInput } from './FormulaEvaluateTableInput';
import {
    FormulaEvaluateTableInputFromJSON,
    FormulaEvaluateTableInputFromJSONTyped,
    FormulaEvaluateTableInputToJSON,
    FormulaEvaluateTableInputToJSONTyped,
} from './FormulaEvaluateTableInput';

/**
 * 
 * @export
 * @interface FormulaEvaluateRequest
 */
export interface FormulaEvaluateRequest {
    /**
     * 
     */
    requestId: string;
    /**
     * 
     */
    methods: Array<string>;
    /**
     * 
     */
    tables: Array<FormulaEvaluateTableInput>;
    /**
     * 
     */
    values: Array<FormulaEvaluateValue>;
    /**
     * 
     */
    results?: FormulaEvaluateResultSpec | null;
}

/**
 * Check if a given object implements the FormulaEvaluateRequest interface.
 */
export function instanceOfFormulaEvaluateRequest(value: object): value is FormulaEvaluateRequest {
    if (!('requestId' in value) || value['requestId'] === undefined) return false;
    if (!('methods' in value) || value['methods'] === undefined) return false;
    if (!('tables' in value) || value['tables'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function FormulaEvaluateRequestFromJSON(json: any): FormulaEvaluateRequest {
    return FormulaEvaluateRequestFromJSONTyped(json, false);
}

export function FormulaEvaluateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'],
        'methods': json['methods'],
        'tables': ((json['tables'] as Array<any>).map(FormulaEvaluateTableInputFromJSON)),
        'values': ((json['values'] as Array<any>).map(FormulaEvaluateValueFromJSON)),
        'results': json['results'] === undefined ? undefined : json['results'] === null ? null : FormulaEvaluateResultSpecFromJSON(json['results']),
    };
}

export function FormulaEvaluateRequestToJSON(json: any): FormulaEvaluateRequest {
    return FormulaEvaluateRequestToJSONTyped(json, false);
}

export function FormulaEvaluateRequestToJSONTyped(value?: FormulaEvaluateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'methods': value['methods'],
        'tables': ((value['tables'] as Array<any>).map(FormulaEvaluateTableInputToJSON)),
        'values': ((value['values'] as Array<any>).map(FormulaEvaluateValueToJSON)),
        'results': FormulaEvaluateResultSpecToJSON(value['results']),
    };
}

